import { Search } from "lucide-react";

interface SearchEmptyStateProps {
  className?: string;
  isSearchActive?: boolean;
}

export function SearchEmptyState({ className, isSearchActive }: SearchEmptyStateProps) {
  return (
    <div className={className} data-testid="search-empty-state">
      <div className="flex flex-col items-center justify-center py-12 text-muted-foreground">
        <Search className="h-12 w-12 mb-4 opacity-50" />
        <p className="text-lg font-medium">No results found</p>
        <p className="text-sm">
          {isSearchActive
            ? "Search covered all dates, all locations, and both current and outcomed animals — try different search terms."
            : "Try changing your search terms or filters."}
        </p>
      </div>
    </div>
  );
}
